var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "inp-subtle",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.submit($event)
      },
      "keydown": _vm.keydown
    }
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    domProps: {
      "textContent": _vm._s(_vm.term || _vm.placeholder)
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    staticClass: "inp-big-focus",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "blur": _vm.blur,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }, _vm.input]
    }
  }), (_vm.options) ? _c('transition-group', {
    staticClass: "ref-select",
    attrs: {
      "name": "staggered",
      "tag": "div"
    }
  }, _vm._l((_vm.options), function(opt, index) {
    return _c('div', {
      key: opt.item,
      staticClass: "ref-option",
      class: {
        'ref-ghost': index === _vm.ghost
      },
      domProps: {
        "textContent": _vm._s(opt.item + ' ' + opt.score)
      },
      on: {
        "mouseenter": function($event) {
          _vm.ghost = index
        },
        "mousedown": function($event) {
          _vm.confirm(opt.item)
        }
      }
    })
  })) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fb7ccc0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputReference.vue
// module id = 70
// module chunks = 1